import React from "react";
import classNames from "classnames";

import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { ResourceAvatar } from "@common/resourceAvatar";
import { Safeguard } from "@scenes/safeguard";
import { resource } from "@planzone/dto";
import { Cell } from "./cell";
import { Props } from "./types";
import styles from "./styles.scss";

function Row(props: Props) {
  const { pushView } = useModal();

  return (
    <Safeguard useCases={[UseCases.retrieveResource]}>
      {({ canRetrieveResource }) => (
        <React.Fragment>
          <div
            className={classNames(styles.resourceCell, {
              [styles.clickable]: canRetrieveResource,
            })}
            onClick={() =>
              canRetrieveResource &&
              pushView({
                key: UseCases.retrieveResource,
                data: props.resource.uuid,
              })
            }
          >
            <div className={styles.avatar}>
              <ResourceAvatar resource={{ ...resource, ...props.resource }} />
            </div>
            <div className={styles.identity}>
              <p className={styles.name}>{props.resource.name}</p>
              <p className={styles.profession}>{props.resource.profession}</p>
            </div>
          </div>
          {props.resource.periods.map((period, index) => (
            <Cell
              key={index}
              resourceId={props.resource.uuid}
              period={period}
              granularity={props.granularity}
              locale={props.locale}
              canEdit={props.canEdit}
            />
          ))}
        </React.Fragment>
      )}
    </Safeguard>
  );
}

export { Row };
